import Vue from "vue";
import Vuex from "vuex";
import User from "@/api/user";
import publicFunction from '@/utils/publicFunction'
import { localStore, sessionStore } from "@/utils/data-management";
import { Loading } from 'element-ui'
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    logoUrl: '',
    userInfo: {},
    companyInfo: {},
    accountType: '1', // 1,个人；2，企业
    userInfos: localStorage.userInfos ? JSON.parse(localStorage.userInfos) : null,
    token: '',
    cityArea: null,
    vertification: false,
    infoStatus: 0, //2 已提交审批 3 审批通过 4 驳回
    companyFormData: {}, // 企业抵押贷款 信息
    cnoticeCenter: false, //通知中心
  },
  mutations: {
    SET_LOGO: (state,logoUrl)=>{
      state.logoUrl = logoUrl
    },
    SET_COMPANY_FORMDATA: (state, companyFormData) => {
      state.companyFormData = companyFormData
    },
    SET_USER_INFOS: (state, userInfos) => {
      state.userInfos = userInfos
      localStore.set("userInfos", userInfos);
    },
    SET_ACCOUNT_TYPE: (state, type) => {
      state.accountType = type
      localStore.set("accountType", type);
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo
    },
    SET_COMPANY_INFO: (state, companyInfo) => {
      state.companyInfo = companyInfo
    },
    SET_CITY_AREA: (state, area) => {
      state.cityArea = area
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_CNOTICE_CENTER: (state, cnoticeCenter) => {
      state.cnoticeCenter = cnoticeCenter
    },
    setVertification:( state,bool) => {
      state.vertification = bool
    }

  },
  actions: {
    cnoticeCenter({ commit }, cnoticeCenter) {
      commit('SET_CNOTICE_CENTER', cnoticeCenter)
    },
    changeCompanyForm({ commit }, companyFormData) {
      commit('SET_COMPANY_FORMDATA', companyFormData);
    },
    changeStatus({ commit, state }) {
      commit('SET_ACCOUNT_TYPE', state.accountType === '1' ? '2' : '1')
    },
    getToken({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    changeArea({ commit }, area) {
      // console.log('area'+area)
      // debugger
      commit('SET_CITY_AREA', area)
    },
    getUserInfo({ state, commit }) {
      if (state.userInfo.token || sessionStore.get('zctToken')) {
        return;
      }
      let ticket = publicFunction.getURLParams('ticket', window.location.href),
      token = publicFunction.getURLParams('token', window.location.href)
      if (ticket && sessionStore.get('ticket') !== ticket) {
        commit('SET_TOKEN', '')
        let data = {
          ticket: ticket || 'Sq57tPiCHdWRPVY9QzjM',
          client: 'client',
          system: 'rural',
          app: 'pc',
        }
        let loading = Loading.service({})
        User.getLogin(data).then(res => {
          if (res.code == 1000) {
            commit('SET_TOKEN', res.data)
            sessionStore.set("zctToken", res.data);
            sessionStore.set("ticket", ticket);
            User.getUserInfo({}).then(res => {
              if (res.code == 1000) {
                state.userInfo = res.data
                commit('SET_USER_INFO', res.data)
                sessionStore.set("userInfo", res.data);
              }
            })
          }
        }).finally(() => {
          loading.close()
        })
      } else if (token && sessionStore.get('zctToken') !== token) {
        commit('SET_TOKEN', token)
        sessionStore.set("zctToken", token)
        User.getUserInfo({}).then(res => {
          if (res.code == 1000) {
            state.userInfo = res.data
            commit('SET_USER_INFO', res.data)
            sessionStore.set("userInfo", res.data)
          }
        })
      }
    }
  },
  modules: {}
});
